import PropTypes from 'prop-types';
import {Dropdown, Form} from 'semantic-ui-react';
import {isNZLocale} from 'lib/PropertyUtils';

PropertyType.propTypes = {
  width: PropTypes.number.isRequired,
  state: PropTypes.string,
  propertyTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
};

export const propertyTypeOptions = () => {
  if (isNZLocale()) {
    return ([
      {key: 'Residential', text: 'Residential', value: 'RESIDENTIAL'},
      {key: 'Commercial', text: 'Commercial', value: 'COMMERCIAL'},
      {key: 'Industrial', text: 'Industrial', value: 'INDUSTRIAL'},
      {key: 'Lifestyle', text: 'Lifestyle', value: 'LIFESTYLE'},
      {key: 'Mining', text: 'Mining', value: 'MINING'},
      {key: 'Arable', text: 'Arable', value: 'ARABLE'},
      {key: 'Dairying', text: 'Dairying', value: 'DAIRYING'},
      {key: 'Forestry', text: 'Forestry', value: 'FORESTRY'},
      {key: 'Horticulture', text: 'Horticulture', value: 'HORTICULTURE'},
      {key: 'Pastoral', text: 'Pastoral', value: 'PASTORAL'},
      {key: 'Utilities', text: 'Utilities', value: 'UTILITIES'},
      {key: 'Specialist', text: 'Specialist', value: 'SPECIALIST'},
      {key: 'Other', text: 'Other', value: 'OTHER'},
    ]);
  } else {
    return ([
      {key: 'House', text: 'House', value: 'HOUSE'},
      {key: 'Unit', text: 'Unit', value: 'UNIT'},
      {key: 'Flats', text: 'Flats', value: 'FLATS'},
      {key: 'Commercial', text: 'Commercial', value: 'COMMERCIAL'},
      {key: 'Business', text: 'Business', value: 'BUSINESS'},
      {key: 'Land', text: 'Land', value: 'LAND'},
      {key: 'Farm', text: 'Farm', value: 'FARM'},
      {key: 'Community', text: 'Community', value: 'COMMUNITY'},
      {key: 'Storage Unit', text: 'Storage Unit', value: 'STORAGE UNIT'},
      {key: 'Other', text: 'Other', value: 'OTHER'},
    ]);
  }
};

export default function PropertyType({width, propertyTypes, onChange}) {
  return (
    <Form.Field width={width} className="property-type">
      <label>Property type</label>
      <Dropdown
        fluid
        options={propertyTypeOptions()}
        placeholder="Property type"
        selection
        multiple
        label="Property type"
        value={propertyTypes}
        onChange={onChange}
      />
    </Form.Field>
  );
}